import { motion } from 'framer-motion';
import { Share2, Heart } from 'lucide-react';
import { NameData } from '../types';
import NameShareableImage from './NameShareableImage';
import NameLikeButton from './NameLikeButton';

interface NameDisplayProps {
  nameData: NameData;
}

export default function NameDisplay({ nameData }: NameDisplayProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="max-w-2xl mx-auto space-y-8"
    >
      <div className="bg-white rounded-lg shadow-lg p-6">
        <h1 className="text-3xl font-bold text-gray-900 mb-4">{nameData.name}</h1>
        <p className="text-lg text-gray-700 mb-6">{nameData.nepali_meaning}</p>
        
        {nameData.personality && (
          <p className="text-gray-600 mb-6">
            <span className="font-medium">Personality:</span> {nameData.personality}
          </p>
        )}
        
        <div className="flex items-center gap-4">
          <span className="px-4 py-2 bg-purple-100 text-purple-600 rounded-full">
            {nameData.popularity}% popularity
          </span>
          <NameLikeButton name={nameData.name} />
        </div>
      </div>

      <NameShareableImage nameData={nameData} />
    </motion.div>
  );
}